import { imgSrc } from "@/lib/api";

export const UserAvatar = ({ user, size = 40, testId }) => {
  const initials = (user?.name || "?")
    .split(" ")
    .map((p) => p[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
  const style = { width: size, height: size, fontSize: size * 0.38 };
  if (user?.avatar_url) {
    return (
      <img
        src={imgSrc(user.avatar_url)}
        alt={user.name}
        style={style}
        data-testid={testId}
        className="rounded-full object-cover border border-[var(--hb-line)] shrink-0"
      />
    );
  }
  return (
    <div
      style={style}
      data-testid={testId}
      className="rounded-full bg-[var(--hb-lime)] text-[var(--hb-ink)] grid place-items-center font-display shrink-0"
    >
      {initials}
    </div>
  );
};
